import { Helmet } from "react-helmet-async";
import {
  DEFAULT_DESCRIPTION,
  OG_IMAGE,
  SITE_ORIGIN,
} from "./seoConfig";

/**
 * Metadatos técnicos para buscadores y redes (sin cambiar estilos ni la UI).
 */
function SeoHelmet({
  title,
  description = DEFAULT_DESCRIPTION,
  path,
  noIndex = false,
  jsonLd = null,
}) {
  const pathNorm = (path && path.startsWith("/") ? path : `/${path || ""}`) || "/";
  const canonical =
    pathNorm === "/" ? `${SITE_ORIGIN}/` : `${SITE_ORIGIN}${pathNorm}`;

  const pageTitle =
    !title || title.includes("|")
      ? title || "Gekkonect"
      : `${title} | Gekkonect`;

  return (
    <Helmet prioritizeSeoTags>
      <title>{pageTitle}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={canonical} />
      <meta
        name="robots"
        content={
          noIndex
            ? "noindex, nofollow"
            : "index, follow, max-image-preview:large"
        }
      />
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content="Gekkonect" />
      <meta property="og:title" content={pageTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={canonical} />
      <meta property="og:locale" content="es_MX" />
      <meta property="og:image" content={OG_IMAGE} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={pageTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={OG_IMAGE} />
      {jsonLd ? (
        <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
      ) : null}
    </Helmet>
  );
}

export default SeoHelmet;
